import ApiRegiones from "@/services/ApiRegiones";
export default {
  data() {
    return {
      ordenModalidad: ["DIURNO", "VESPERTINO", "SEMIPRESENCIAL", "A_DISTANCIA"]
    };
  },
  methods: {
    ordenarPorCondicionesNoPresenciales(list) {
      let ordenado;
      ordenado = this.ordenNombreCarrera(list);
      ordenado = this.ordenRegion(ordenado);
      ordenado = this.ordenAcreditacion(ordenado);
      return ordenado;
    },
    ordenarPorCondiciones(list) {
      let ordenado;
      ordenado = this.ordenarModalidad(list);
      ordenado = this.ordenNombreCarrera(ordenado);
      ordenado = this.ordenAcreditacion(ordenado);
      ordenado = this.ordenRegion(ordenado);
      return ordenado;
    },
    ordenarModalidad(list) {
      let ordenado = list.sort((a, b) => {
        let n1 = this.ordenModalidad.indexOf(a.datos.jornada);
        let n2 = this.ordenModalidad.indexOf(b.datos.jornada);
        return n1 - n2;
      });
      return ordenado;
    },
    ordenNombreCarrera(list) {
      let ordenado = list.sort((a, b) => {
        return a.datos.nombre.localeCompare(b.datos.nombre);
      });
      return ordenado;
    },
    ordenAcreditacion(list) {
      let ordenado = list.sort((a, b) => {
        let n1 = this.decisionAcreditacion(
          a.institucion.acreditacion.anios,
          a.institucion.observacionAcreditacionCNA
        );
        let n2 = this.decisionAcreditacion(
          b.institucion.acreditacion.anios,
          b.institucion.observacionAcreditacionCNA
        );
        return n2 - n1;
      });
      return ordenado;
    },
    decisionAcreditacion(anio, cna) {
      let res;
      if (anio) {
        res = anio + 2;
      } else {
        if (cna) {
          res = 2;
        } else {
          res = 1;
        }
      }
      return res;
    },
    ordenRegion(list) {
      let regiones = ApiRegiones.getSoloRegiones();
      let ordenado = list.sort((a, b) => {
        let n1 = regiones.indexOf(a.sede.region);
        let n2 = regiones.indexOf(b.sede.region);
        return n1 - n2;
      });
      return ordenado;
    },
    ordenNombreInstitucion(list) {
      let ordenado = list.sort((a, b) => {
        return a.institucion.nombre.localeCompare(b.institucion.nombre);
      });
      return ordenado;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/OrdenamientoCarreras.js